import { Link2 } from "lucide-react";
import { WorkspaceDocument } from "../types";

interface BacklinksPanelProps {
  /** Notes that link to the active note via `[[wikilinks]]`. */
  backlinks: WorkspaceDocument[];
  onOpen: (id: string) => void;
}

export const BacklinksPanel = ({ backlinks, onOpen }: BacklinksPanelProps) => (
  <aside className="panel backlinks-panel" aria-label="Backlinks">
    <div className="panel-title">
      <Link2 size={18} />
      <span>Backlinks</span>
      {backlinks.length > 0 && <span className="panel-count">{backlinks.length}</span>}
    </div>
    {backlinks.length === 0 ? (
      <p className="muted">Notes that link here with [[…]] show up here.</p>
    ) : (
      <nav className="backlinks-list">
        {backlinks.map((doc) => (
          <button
            key={doc.id}
            type="button"
            className="backlinks-item"
            title={doc.name}
            onClick={() => onOpen(doc.id)}
          >
            {doc.name || "Untitled"}
          </button>
        ))}
      </nav>
    )}
  </aside>
);
